// 管理员相关的api
import request from '@/utils/request'
// 获取管理员列表
export function getAdministratorList(data) {
  return request({
    url: '/admin/admin/list',
    method: 'post',
    data: data
  })
}
// 获取全部角色列表
export function getAllRoles() {
  return request({
    url: '/admin/role/all',
    method: 'post'
  })
}
// 添加管理员
export function addAdministrator(data) {
  return request({
    url: '/admin/admin/save',
    method: 'post',
    data: data
  })
}
// 删除管理员
export function delAdministrator(data) {
  return request({
    url: '/admin/admin/delete',
    method: 'post',
    data: data
  })
}
// 更新管理员信息
export function updateAdministrator(data) {
  return request({
    url: '/admin/admin/update',
    method: 'post',
    data: data
  })
}
export function dataList(data) {
  return request({
    url: '/admin/data/list',
    method: 'post',
    data: data
  })
}
export function statDataList(data) {
  return request({
    url: '/admin/statData1/list',
    method: 'post',
    data: data
  })
}